import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

import { SidebarItemProps } from './types';

export const SidebarItem = ({ href, children, active = false, subItems, isBlank, variant }: SidebarItemProps) => {
  const location = useLocation();
  const pathname = location.pathname;

  const isActive = active;
  const [isOpen, setIsOpen] = useState(isActive && subItems ? true : false);

  const hasSubItems = subItems && subItems.length > 0;

  const activeColor =
    variant === 'instagram'
      ? isActive
        ? 'text-[#db2777] bg-pink-50'
        : 'hover:bg-gray-100'
      : isActive
        ? 'bg-blue-50 text-blue-600'
        : 'hover:bg-gray-100';
  return (
    <div className="mb-1">
      <Link
        to={hasSubItems ? '#' : href}
        onClick={(e) => {
          if (hasSubItems) {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
        target={isBlank ? '_blank' : '_parent'}
        className={`flex items-center justify-between px-3 py-2 rounded-md text-sm ${activeColor}`}
      >
        <span>{children}</span>
        {hasSubItems && (isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />)}
      </Link>

      {hasSubItems && isOpen && (
        <div className="ml-4 mt-1 space-y-1">
          {subItems.map((item, index) => (
            <Link
              key={index}
              to={item.href}
              className={`block px-3 py-1.5 rounded-md text-sm ${
                pathname === item.href ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
